import { ColumnsType } from "antd/es/table";
import { QuarryListDataType } from "../../../Types/quarryDatabaseTypes";
import { QuarrySortByColumns } from "../../../enums/QuarryDatabaseEnum";
import { TableSortTypes } from "../../../enums/ViewListingTypes";
import DescriptionCell from "../../../reusable-components/DescriptionCell";
import copyIcon from "../../../assets/images/copy-icon.svg";
import styles from "./QuarryTableView.module.scss";
import ConditionalRender from "../../../reusable-components/ConditionalRender";
import { message, Popover } from "antd";
import { PlacementPositions } from "../../../enums/PlacementPositionsEnums";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { EllipsisOutlined } from "@ant-design/icons";

interface GetQuarryColumnsParams {
  sortColumn?: QuarrySortByColumns | null;
  sortOrder?: TableSortTypes | null;
  handleEditNavigate?: (id: string) => void;
  handleDeleteSelect?: (id: string) => void;
}

const renderWithHyphen = (text) => (text ? text : "-");

const convertSortOrder = (sortOrder: TableSortTypes | null) => {
  if (!sortOrder) return null;
  return sortOrder === TableSortTypes.ASCEND ? "ascend" : "descend";
};

export const getQuarryColumns = (
  params?: GetQuarryColumnsParams
): ColumnsType<QuarryListDataType> => [
  {
    title: "QUARRY NAME",
    key: QuarrySortByColumns.QUARRY_NAME,
    dataIndex: "quarryName",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.QUARRY_NAME
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "LOCATION",
    key: QuarrySortByColumns.LOCATION,
    dataIndex: "location",
    width: "180px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.LOCATION
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "COORDINATES",
    key: "coordinates",
    dataIndex: "coordinates",
    width: "120px",
    render: (val) => {
      const coordinates = val?.split(" ")?.join(", ");
      return (
        <ConditionalRender
          visible={!coordinates?.includes(null)}
          fallback={"-"}
        >
          <div className={styles.descriptionCell}>
            <DescriptionCell text={coordinates} />
            <img
              src={copyIcon}
              className={styles.copyIcon}
              alt="Copy"
              onClick={() => {
                navigator.clipboard.writeText(coordinates);
                message.success("Coordinates copied!");
              }}
            />
          </div>
        </ConditionalRender>
      );
    },
  },
  {
    title: "PHONE NUMBER",
    key: "phone",
    dataIndex: "phone",
    render: renderWithHyphen,
  },
  {
    title: "MATERIAL TYPE",
    key: QuarrySortByColumns.TYPE,
    dataIndex: "type",
    width: "220px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.TYPE
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "ACCOUNT LIMIT",
    key: QuarrySortByColumns.ACCOUNT_LIMIT,
    dataIndex: "accountLimit",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.ACCOUNT_LIMIT
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "CURRENT BALANCE",
    key: QuarrySortByColumns.CURRENT_BALANCE,
    dataIndex: "currentBalance",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.CURRENT_BALANCE
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "OVERDUE BALANCE",
    key: QuarrySortByColumns.OVERDUE_BALANCE,
    dataIndex: "overdueBalance",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.OVERDUE_BALANCE
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "LIFETIME PURCHASES",
    key: QuarrySortByColumns.LIFETIME_PURCHASES,
    dataIndex: "lifeTimePurchases",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.LIFETIME_PURCHASES
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "LAST 3 MONTHS",
    key: QuarrySortByColumns.LAST_3_MONTHS,
    dataIndex: "last3Months",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.LAST_3_MONTHS
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "LAST 30 DAYS",
    key: QuarrySortByColumns.LAST_30_DAYS,
    dataIndex: "last30Days",
    width: "120px",
    sorter: true,
    sortOrder:
      params?.sortColumn === QuarrySortByColumns.LAST_30_DAYS
        ? convertSortOrder(params?.sortOrder)
        : null,
    render: renderWithHyphen,
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    width: "50px",
    fixed: "right",
    render: (_, record) => {
      return (
        <Popover
          placement={PlacementPositions.LEFT}
          content={
            <>
              <div
                className={styles.PopoverContent}
                onClick={() => params.handleEditNavigate(record?.id)}
              >
                <MdModeEdit />
                Edit
              </div>
              <div
                className={styles.PopoverContent}
                onClick={() => params?.handleDeleteSelect(record?.id)}
              >
                <MdDelete />
                Delete
              </div>
            </>
          }
        >
          <EllipsisOutlined
            style={{ fontSize: "30px", color: "#C3C8CD" }}
            className="action-ellipsis-button"
          />
        </Popover>
      );
    },
  },
];
